import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.13.2@vant/es/lazyload/index.js
// module id = 789
// module chunks = 319